import React, { createContext, useState, useContext } from "react";
import Modal from "./Modal";

type ModalContextType = {
    openModal: (content: React.ReactNode, useWidth: boolean) => void;
    closeModal: () => void;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState<React.ReactNode>(null);
    const [useWidth, setUseWidth] = useState<boolean>(false);

    const openModal = (modalContent: React.ReactNode) => {
        setContent(modalContent);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setContent(null);
    };

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}
            <Modal isOpen={isOpen} onClose={closeModal} useWidth={useWidth}>
                {content}
            </Modal>
        </ModalContext.Provider>
    );
}

export function useModal() {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
}
